module.exports = __webpack_public_path__ + "media/assets/arrowDrawing-ecc6237075cad8d727eef9af96c1b9a3.svg";